import React from "react";
import "./LivePriceTicker.css";
import "./ChartLoadingOverlay.css";

const CANDLE_HEIGHTS = [18, 30, 22, 40, 28, 46, 34, 52, 38];

/**
 * Covers the chart while candles are being fetched: the chart grid stays visible,
 * a thin line sweeps across it and a row of placeholder candles pulses.
 */
export default function ChartLoadingOverlay({
  symbol,
  timeframeLabel,
  source = "cTrader",
  background = "#050608",
  gridColor = "#17191d",
  textColor = "#eceef1",
  mutedColor = "#9097a3",
}) {
  return (
    <div
      className="lwt-loading"
      role="status"
      aria-live="polite"
      style={{
        backgroundColor: background,
        backgroundImage: `linear-gradient(${gridColor} 1px, transparent 1px), linear-gradient(90deg, ${gridColor} 1px, transparent 1px)`,
        backgroundSize: "100% 12.5%, 6.25% 100%",
        color: textColor,
      }}
    >
      <div className="lwt-loading__scan" aria-hidden="true" style={{ background: textColor }} />
      <div className="lwt-loading__card" style={{ background }}>
        <div className="lwt-loading__candles" aria-hidden="true">
          {CANDLE_HEIGHTS.map((h, i) => (
            <span
              key={i}
              className="lwt-loading__candle"
              style={{ height: h, background: mutedColor, animationDelay: `${i * 0.1}s` }}
            />
          ))}
        </div>
        <span className="lwt-loading__symbol">{symbol}</span>
        <span className="lwt-loading__detail" style={{ color: mutedColor }}>
          Loading {timeframeLabel ? `${timeframeLabel} candles` : "candles"} from {source}
        </span>
      </div>
    </div>
  );
}
